import { LearningArticle } from "../types/learningArticle";
import HowToCard from "./howToCard";
import InsightCard from "./insightCard";

export type ArticleCardProps = {
  article: LearningArticle;
};

export function ArticleCard(props: ArticleCardProps) {
  switch (props.article?.category) {
    case "insight":
      return <InsightCard {...props.article} />;
    case "howTo":
      return <HowToCard {...props.article} />;
    /* TODO implement events
    case "event":
      return <EventCard article={props.article} />;
       */
    default:
      // TODO some default article render? skip uncategorized articles?
      return null;
  }
}

export default ArticleCard;
